import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ConditionalComponent from './ConditionalComponent';
import TableModalComponent from './TableModalComponent';
import { unicode } from '../helpers';

const ArtifactHitCountModalComponent = ({
  visible,
  title,
  artifacts,
  baselineHitCounts,
  hitCounts,
  scanKey,
  isExpectedBaseline,
  diffOnly,
  setDiffOnly,
  onHide,
  openConfirm,
  isCcf
}) => {
  const rows = artifacts.reduce((result, art, i) => {
    let delta = hitCounts[art] - baselineHitCounts[art];

    if (delta === 0 && diffOnly) {
      return result;
    }

    if (isNaN(delta)) {
      if (hitCounts[art] !== undefined) {
        delta = '+' + hitCounts[art];
      } else if (baselineHitCounts[art] !== undefined) {
        delta = '-' + baselineHitCounts[art];
      } else {
        delta = '';
      }
    } else if (delta > 0) {
      delta = '+' + delta.toString();
    }

    result.push(
      <tr key={i}>
        <td>{art}</td>
        <td>{hitCounts[art] || 'N/A'}</td>
        <td>{baselineHitCounts[art] || 'N/A'}</td>
        <td className={delta !== 0 ? 'bad-metric' : undefined}>{delta}</td>
        {
          isExpectedBaseline ?
            <td>
              <Button
                onClick={() => openConfirm(scanKey, isCcf, art, parseInt(delta))}
                disabled={!delta}
              >
                Expect
              </Button>
            </td> :
            null
        }
      </tr>
    );
    return result;
  }, []);

  const beforeTable = (
    <div style={{ display: 'block' }} className="pull-right">
      <label>
        Only Show Differences
        <input
          type="checkbox"
          checked={diffOnly}
          style={{ marginLeft: '10px' }}
          onChange={e => setDiffOnly(e.target.checked)}
        />
      </label>
    </div>
  );

  const afterTable = (
    <ConditionalComponent condition={rows.length === 0}>
      <h3>No hit count differences found</h3>
    </ConditionalComponent>
  );

  const headers = [
    'Artifact Name', 'Current Hit Count', 'Baseline Hit Count', unicode.DELTA
  ];

  return (
    <TableModalComponent
      title={title}
      isVisible={visible}
      isTableVisible={rows.length > 0}
      onHide={onHide}
      tableHeaders={headers}
      tableRows={rows}
      beforeTableChildren={beforeTable}
      afterTableChildren={afterTable}
    />
  );
};

ArtifactHitCountModalComponent.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  artifacts: PropTypes.array.isRequired,
  baselineHitCounts: PropTypes.object.isRequired,
  hitCounts: PropTypes.object.isRequired,
  scanKey: PropTypes.string.isRequired,
  isExpectedBaseline: PropTypes.bool,
  diffOnly: PropTypes.bool,
  setDiffOnly: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  openConfirm: PropTypes.func.isRequired,
  isCcf: PropTypes.bool
};

export default ArtifactHitCountModalComponent;


// WEBPACK FOOTER //
// src/Components/ArtifactHitCountModalComponent.jsx